import styled from 'styled-components';

export const HeaderContainer = styled.section`
  background-image: ${(props) => `url(${props.backgroundImage})`};
  position: relative;
  padding: 30px 0 30px;
  display: block;
  font-family: 'Avenir Next LT W01 Demi';
  font-size: 30px;
  font-weight: 100;
  color: #fff;
  text-align: center;
`;

export const HeaderContent = styled.div`
  margin: .3rem 0;
`;
